import React, { useState } from "react"
import Svg from "../../shared/_svgs/svg"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import PropTypes, { string } from "prop-types"
import { object } from "underscore"

export default function CarparkPricingSummaryComponent({
  parkingProductsCards,
  contentReferences,
  defaultSortingLabel,
  distanceShortToLongLabel,
  distanceLongToShortLabel,
  priceCheapToExpensiveLabel,
  priceExpensiveToCheapLabel,
  resultLabel,
  resultsLabel,
}) {
  const [selectedCategory, setSelectedCategory] = useState(undefined)
  const [selectedSorting, setSelectedSorting] = useState(defaultSortingLabel)
  const [selectedCategoryReference, setSelectedCategoryReference] = useState(undefined)
  const [selectedLatitude, setSelectedLatitude] = useState(undefined)
  const [selectedLongitude, setSelectedLongitude] = useState(undefined)
  const [activatedMap, setActivatedMap] = useState(false)

  const sortedProducts = [...parkingProductsCards].sort((a, b) => {
    if (selectedSorting == defaultSortingLabel) return 0
    if (a.__type__ === "ParkingGenericCardBlock") return 1
    if (b.__type__ === "ParkingGenericCardBlock") return -1

    switch (selectedSorting) {
      case priceCheapToExpensiveLabel:
        return a.minimumBookingPrice - b.minimumBookingPrice
      case priceExpensiveToCheapLabel:
        return b.minimumBookingPrice - a.minimumBookingPrice
      case distanceShortToLongLabel:
        return a.minimumDistanceToAirport - b.minimumDistanceToAirport
      case distanceLongToShortLabel:
        return b.maximumDistanceToAirport - a.maximumDistanceToAirport
      default:
        return 0
    }
  })

  const htmlCategoryPills =
    contentReferences && contentReferences.length > 0
      ? contentReferences.map((reference) => {
          return (
            <CategoryPill
              key={reference.ContentId}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedCategoryReference={selectedCategoryReference}
              setSelectedCategoryReference={setSelectedCategoryReference}
              contentReference={reference}
            />
          )
        })
      : undefined

  const htmlProductCards =
    sortedProducts && sortedProducts.length > 0
      ? sortedProducts
          .filter((card) => {
            if (!selectedCategory) {
              return true
            }
            const numberSelectedCategory = Number(selectedCategory)
            if (card && card.selectedParkingProductCardCategories && card.selectedParkingProductCardCategories.length > 0)
              return card.selectedParkingProductCardCategories.includes(numberSelectedCategory)

            return
          })
          .map((card, index) => {
            if (card.__type__ === "ParkingProductCardBlock") {
              return (
                <ParkingProductCardBlock
                  key={card.carparkCode + "-" + index}
                  setActivatedMap={setActivatedMap}
                  setSelectedLatitude={setSelectedLatitude}
                  selectedLatitude={selectedLatitude}
                  setSelectedLongitude={setSelectedLongitude}
                  selectedLongitude={selectedLongitude}
                  {...card}
                />
              )
            } else if (card.__type__ === "ParkingGenericCardBlock") {
              return <ParkingGenericCardBlock key={card.productName + "-" + index} {...card} />
            }
            return null
          })
      : undefined

  return (
    <section className={"carpark-summary-section w--wider"}>
      <div className="category-container-outer">
        <div className="category-container">{htmlCategoryPills}</div>
        {contentReferences && contentReferences.length > 0
          ? contentReferences.map((reference, index) => {
              return (
                <div
                  key={reference.ContentId + "-" + index}
                  className={`explainer-section rich-text w--narrow ${selectedCategoryReference && selectedCategoryReference.ContentId == reference.ContentId ? "selected" : "hidden"}`}
                >
                  {ReactHtmlParser(reference.CategoryExplainerText)}
                </div>
              )
            })
          : undefined}
      </div>
      <div className="results-sorting-outer">
        <div className="results-sorting">
          <div className="sorting-options">
            <SortOptions
              defaultSortingLabel={defaultSortingLabel}
              distanceLongToShortLabel={distanceLongToShortLabel}
              distanceShortToLongLabel={distanceShortToLongLabel}
              priceCheapToExpensiveLabel={priceCheapToExpensiveLabel}
              priceExpensiveToCheapLabel={priceExpensiveToCheapLabel}
              selectedSorting={selectedSorting}
              setSelectedSorting={setSelectedSorting}
            />
          </div>
          <div className="product-cards-results">
            <p>
              {htmlProductCards && htmlProductCards.length != 1 ? (
                <span>
                  {htmlProductCards.length} {resultsLabel}
                </span>
              ) : (
                <span>
                  {htmlProductCards.length} {resultLabel}
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="product-card-outer-container">
        <div className="product-card-container">{htmlProductCards}</div>
      </div>
      {activatedMap ? (
        <div className="summary-map-overlay">
          <div className={"overlay overlay--modal overlay--fixed is-active"}>
            <div className={"modal modal--iframe-modal"}>
              <OutsideClickTrigger
                onOutsideClick={() => {
                  setActivatedMap(false)
                  setSelectedLatitude(undefined)
                  setSelectedLongitude(undefined)
                }}
              >
                <React.Fragment>
                  <button
                    autoFocus={true}
                    className="button button--icon modal-close close-map"
                    onClick={() => {
                      setActivatedMap(false)
                      setSelectedLatitude(undefined)
                      setSelectedLongitude(undefined)
                    }}
                  >
                    <span className="icon">
                      <svg className="svg-icon svg-icon--close-new">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  </button>
                  <div className="modal__content modal__content--no-padding">
                    <div className="modal__content__inner">
                      <div className="modal__middle" style={{ padding: "0px", margin: "0px" }}>
                        <div className="modal__middle__inner">
                          <iframe
                            title="Google Maps Modal"
                            id="gmap_canvas"
                            src={`https://maps.google.com/maps?q=${selectedLatitude},${selectedLongitude}&output=embed`}
                            width="100%"
                            height="500"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </OutsideClickTrigger>
            </div>
          </div>
        </div>
      ) : undefined}
    </section>
  )
}

CarparkPricingSummaryComponent.propTypes = {
  parkingProductsCards: PropTypes.arrayOf(object),
  contentReferences: PropTypes.arrayOf(object),
  defaultSortingLabel: PropTypes.string,
  distanceShortToLongLabel: PropTypes.string,
  distanceLongToShortLabel: PropTypes.string,
  priceCheapToExpensiveLabel: PropTypes.string,
  priceExpensiveToCheapLabel: PropTypes.string,
  resultLabel: PropTypes.string,
  resultsLabel: PropTypes.string,
}

function ParkingProductCardBlock({
  bookingPricingType,
  carparkCode,
  driveInPrice,
  latitude,
  selectedLatitude,
  setSelectedLatitude,
  longitude,
  selectedLongitude,
  setSelectedLongitude,
  setActivatedMap,
  mapLinkLabel,
  minimumBookingPrice,
  pricingDescription,
  productName,
  readMoreButtonLabel,
  readMoreButtonLink,
  readMoreButtonLinkTitle,
  uspTexts,
  activateCampaign,
  campaignText,
  productCardStyle,
}) {
  const cardStyle = SelectionFactoryHelper.getFromSelectionFactory(productCardStyle) ?? ""

  const handleMapsButtonClick = () => {
    if (!selectedLatitude && !selectedLongitude) {
      setSelectedLatitude(latitude)
      setSelectedLongitude(longitude)
      setActivatedMap(true)
    } else {
      setSelectedLatitude(undefined)
      setSelectedLongitude(undefined)
      setActivatedMap(false)
    }
  }

  let modifiedDescription = pricingDescription.replace(/\{minimumBookingPrice\}/, `<span class="minimum-price">{minimumBookingPrice}</span>`)

  if (modifiedDescription.includes("<br />")) {
    modifiedDescription = modifiedDescription.replace(/<br \/>((.|\n)*?)<\/p>/, `<br /><span class="after-br">$1</span></p>`)
  }

  return (
    <div className="summary-card-outer-container product-card">
      {activateCampaign ? (
        <div className="discount-container-outer">
          <div className="discount-container">
            <p className="discount-text">{campaignText}</p>
          </div>
        </div>
      ) : undefined}
      <div className={`summary-card-container ${activateCampaign ? "active-campaign" : ""}`}>
        <div className={`summary-card-tophalf ${cardStyle}`}>
          <div className="parking-product-details">
            <p className="parking-product-code">{carparkCode}</p>
            <p className="parking-product-name">{productName}</p>
          </div>
          <div className="product-pricing-details">
            <p className="booking-type">{bookingPricingType}</p>
            <div className="rich-text">
              {ReactHtmlParser(
                modifiedDescription.formatUnicorn({
                  minimumBookingPrice: minimumBookingPrice.toLocaleString("da-DK"),
                  driveInPrice: driveInPrice.toLocaleString("da-DK"),
                }),
              )}
            </div>
          </div>
        </div>
        <div className="summary-card-bottomhalf">
          <div className="summary-usp-content">
            {uspTexts && uspTexts.length > 0
              ? uspTexts.map((usp, index) => {
                  return (
                    <span key={productName + "-" + carparkCode + "-" + usp + "-" + index} className="summary-usp-item">
                      <Svg iconName="checkmark2" />
                      <p>{usp}</p>
                    </span>
                  )
                })
              : undefined}
          </div>
          <div className="map-button-content">
            <button className="map-link" onClick={() => handleMapsButtonClick()}>
              <Svg fillColor="transparent" iconName="Addres" />
              <p className="map-link-label">{mapLinkLabel}</p>
            </button>
            <a className="summary-read-more" title={readMoreButtonLinkTitle} href={readMoreButtonLink}>
              {readMoreButtonLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

ParkingProductCardBlock.propTypes = {
  bookingPricingType: PropTypes.string,
  carparkCode: PropTypes.string,
  driveInPrice: PropTypes.number,
  latitude: PropTypes.string,
  selectedLatitude: PropTypes.string,
  setSelectedLatitude: PropTypes.func,
  longitude: PropTypes.string,
  selectedLongitude: PropTypes.string,
  setSelectedLongitude: PropTypes.func,
  setActivatedMap: PropTypes.func,
  mapLinkLabel: PropTypes.string,
  minimumBookingPrice: PropTypes.number,
  pricingDescription: PropTypes.string,
  productName: PropTypes.string,
  readMoreButtonLabel: PropTypes.string,
  readMoreButtonLink: PropTypes.string,
  readMoreButtonLinkTitle: PropTypes.string,
  uspTexts: PropTypes.arrayOf(string),
  activateCampaign: PropTypes.bool,
  campaignText: PropTypes.string,
  productCardStyle: PropTypes.arrayOf(object),
}

function ParkingGenericCardBlock({ productLines, productName, readMoreButtonLabel, readMoreButtonLink, readMoreButtonLinkTitle, uspTexts }) {
  return (
    <div className="summary-card-outer-container generic-card">
      <div className="summary-card-container">
        <div className="summary-card-tophalf generic">
          <div className="parking-product-details">
            <div className="parking-product-code"></div>
            <p className="parking-product-name">{productName}</p>
          </div>
          <div className="parking-product-generic-lines">
            {productLines && productLines.length > 0
              ? productLines.map((line, index) => {
                  return (
                    <p key={productName + "-" + (line.productCode ?? "index" + "" + index)} className="summary-generic-productline">
                      <span className="summary-product-line-name">
                        <strong className="code">{line.productCode}</strong> {line.productName}
                      </span>
                      <span className="summary-product-line-price">
                        <span className="summary-price-emphasized">{line.productPrice} </span>
                        <strong>{line.productCurrency}</strong>
                        <span className="summary-duration-definition">{line.productDurationDefinition}</span>
                      </span>
                    </p>
                  )
                })
              : undefined}
          </div>
        </div>
        <div className="summary-card-bottomhalf">
          <div className="summary-usp-content">
            {uspTexts && uspTexts.length > 0
              ? uspTexts.map((usp, index) => {
                  return (
                    <span key={productName + "-" + index + "-" + usp} className="summary-usp-item">
                      <Svg iconName="checkmark2" />
                      <p>{usp}</p>
                    </span>
                  )
                })
              : undefined}
          </div>
          <div className="map-button-content">
            <a className="summary-read-more" title={readMoreButtonLinkTitle} href={readMoreButtonLink}>
              {readMoreButtonLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

ParkingGenericCardBlock.propTypes = {
  productLines: PropTypes.arrayOf(object),
  productName: PropTypes.string,
  readMoreButtonLabel: PropTypes.string,
  readMoreButtonLink: PropTypes.string,
  readMoreButtonLinkTitle: PropTypes.string,
  uspTexts: PropTypes.arrayOf(string),
}

function CategoryPill({ selectedCategory, setSelectedCategory, contentReference, selectedCategoryReference, setSelectedCategoryReference }) {
  const handleSetCategory = () => {
    if (selectedCategory != contentReference.ContentId) {
      setSelectedCategory(contentReference.ContentId)
      setSelectedCategoryReference(contentReference)
    } else {
      setSelectedCategory(undefined)
      setSelectedCategoryReference(undefined)
    }
  }
  const categoryIsSet = selectedCategory == contentReference.ContentId

  return (
    <div className="category-pill-container-outer">
      <button className={`category-pill-container ${categoryIsSet ? "selected" : ""}`} onClick={() => handleSetCategory()}>
        <span>
          <Svg iconName="checkmark2" />
        </span>
        <p>{contentReference.Name}</p>
      </button>
    </div>
  )
}

CategoryPill.propTypes = {
  selectedCategory: PropTypes.string,
  setSelectedCategory: PropTypes.func,
  contentReference: PropTypes.object,
  selectedCategoryReference: PropTypes.object,
  setSelectedCategoryReference: PropTypes.func,
}

function SortOptions({
  defaultSortingLabel,
  distanceShortToLongLabel,
  distanceLongToShortLabel,
  priceCheapToExpensiveLabel,
  priceExpensiveToCheapLabel,
  selectedSorting,
  setSelectedSorting,
}) {
  const handleSelectChange = (value) => {
    setSelectedSorting(value)
    setIsSortMenuOpen(false)
  }

  const [isSortMenuOpen, setIsSortMenuOpen] = useState(false)
  const tabindexvalue = isSortMenuOpen ? 0 : -1

  return (
    <div className="sort-menu">
      <OutsideClickTrigger onOutsideClick={() => setIsSortMenuOpen(false)}>
        <button className="sort-toggler" onClick={() => setIsSortMenuOpen(!isSortMenuOpen)} aria-expanded={isSortMenuOpen}>
          {selectedSorting}
          <Svg iconName="arrowdownangle" iconClass={`icon ${isSortMenuOpen ? "open" : "closed"}`} />
        </button>

        <div className={`sort ${isSortMenuOpen ? "open" : "closed"}`}>
          <div className="options" role="listbox" aria-label="sort menu">
            <span className="option">
              <button tabIndex={tabindexvalue} onClick={() => handleSelectChange(defaultSortingLabel)}>
                {defaultSortingLabel}
              </button>
            </span>
            <span className="option">
              <button tabIndex={tabindexvalue} onClick={() => handleSelectChange(distanceShortToLongLabel)}>
                {distanceShortToLongLabel}
              </button>
            </span>
            <span className="option">
              <button tabIndex={tabindexvalue} onClick={() => handleSelectChange(distanceLongToShortLabel)}>
                {distanceLongToShortLabel}
              </button>
            </span>
            <span className="option">
              <button tabIndex={tabindexvalue} onClick={() => handleSelectChange(priceCheapToExpensiveLabel)}>
                {priceCheapToExpensiveLabel}
              </button>
            </span>
            <span className="option">
              <button tabIndex={tabindexvalue} onClick={() => handleSelectChange(priceExpensiveToCheapLabel)}>
                {priceExpensiveToCheapLabel}
              </button>
            </span>
          </div>
        </div>
      </OutsideClickTrigger>
    </div>
  )
}
SortOptions.propTypes = {
  defaultSortingLabel: PropTypes.string,
  distanceShortToLongLabel: PropTypes.string,
  distanceLongToShortLabel: PropTypes.string,
  priceCheapToExpensiveLabel: PropTypes.string,
  priceExpensiveToCheapLabel: PropTypes.string,
  selectedSorting: PropTypes.string,
  setSelectedSorting: PropTypes.func,
}
